import type { Action } from 'react-sweet-state';
import type { State } from '../../types';

export const lockSelection =
	(): Action<State> =>
	({ setState }) =>
		setState({ isLocked: true });
